import { Grid, Card, CircularProgress, makeStyles, Typography, MenuItem, Button } from '@material-ui/core'
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';
import { useReactToPrint } from 'react-to-print';
import { cleanPracticaPorConvenio, fetchPracticaPorConvenio, generateExcelPracticaXConvenio, generatePDFPracticaXConvenio } from '../../../../actions/contrataciones/contratacionesReportes';
import { fetchProvincias } from '../../../../actions/cbos/provincias';
import { fetchLocalidades } from '../../../../actions/cbos/localidades';
import { SelectValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import moment from "moment";
import BuscadorPractica from '../../convenios/BuscadorPractica';
import { startAlerta } from '../../../../actions/ui/alertas';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
}));

// const getOnlyLocalidades = (prestadores, CentrosMedicos) => {
//     let aux = []

//     prestadores.forEach(element => {
//         element.cartillaPrestadores.forEach(cartilla => {
//             if (cartilla.idCentroMedico === null) {
//                 if (cartilla.cartillaPrestadoresDomicilio?.idLocalidad)
//                     aux.push(cartilla.cartillaPrestadoresDomicilio.idLocalidad)
//             } else {
//                 const centroEncontrado = CentrosMedicos.find(x => x.idCentroMedico === cartilla.idCentroMedico);
//                 if (centroEncontrado?.idLocalidad)
//                     aux.push(centroEncontrado?.idLocalidad)
//             }
//         });
//     });

//     return aux
// }

let disableLocalidad = {};

const PrestadoresPorPracticas = () => {
    const classes = useStyles();
    const dispatch = useDispatch()

    const { items: localidades } = useSelector((state) => state.localidades);
    const { items: provincias } = useSelector((state) => state.provincias);
    const { prestadoresPorPractica, loading } = useSelector(state => state.contratacionesReportes);
    // const { items: CentrosMedicos } = useSelector((state) => state.centrosMedicosPropios);

    const buscadorRef = useRef(null);
    const componentRef = React.useRef();

    const FormInicial = {
        idProvincia: "",
        idLocalidad: "",
        parametroBusqueda: null
    }
    const [
        formValues,
        handleInputChange,
        ,
        setearValor
    ] = useForm(FormInicial);
    
    const {
        idProvincia,
        idLocalidad,
        parametroBusqueda
    } = formValues;

    if(provincias.length > 0)
        disableLocalidad = idProvincia === provincias.find(item => item.descripcion_provincia === 'CAPITAL FEDERAL').id_provincia;

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const onSubmitconsultarPractica = (e) => {
        e.preventDefault();
        if (parametroBusqueda !== null) {
            dispatch(fetchPracticaPorConvenio(formValues.parametroBusqueda, formValues.idLocalidad, formValues.idProvincia));
        } else {
            dispatch(startAlerta("Debe ingresar una practica"));
        }
    }

    useEffect(() => {
        dispatch(cleanPracticaPorConvenio());
        if (localidades.length === 0) {
            dispatch(fetchLocalidades());
        }
        if (provincias.length === 0) {
            dispatch(fetchProvincias());
        }
        // if (CentrosMedicos.length === 0) {
        //     dispatch(fetchCentrosMedicosPropios());
        // }
    }, [dispatch, localidades, provincias]);

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center" style={{ padding: 16 }}>
                <Grid item xs={12} md={10}>
                    <Card>
                        <Grid container spacing={1} direction="row" justify="center" alignItems="center" >
                            <Grid item xs={8}>
                                <Typography variant="subtitle1" style={{ padding: 16 }}>
                                    Practicas Por Prestadores
                                    {
                                        loading &&
                                        <CircularProgress size={24} style={{ marginLeft: 15 }} />
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                {
                                    <ToolbarXLSPDF
                                        handlePrint={handlePrint}
                                        handleExportExcel={() => dispatch(generateExcelPracticaXConvenio(formValues.parametroBusqueda, formValues.idLocalidad, formValues.idProvincia))}
                                        handleGeneratePdf={() => dispatch(generatePDFPracticaXConvenio(formValues.parametroBusqueda, formValues.idLocalidad, formValues.idProvincia))}
                                    />}
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} direction="row" justify="center" alignItems="center" style={{ padding: 16 }}>

                            <ValidatorForm
                                onSubmit={onSubmitconsultarPractica}
                                style={{ flexGrow: "1", margin: "1rem" }}
                            >
                                <Grid container spacing={1} style={{ padding: 16 }}>
                                    <Grid item xs={6}>
                                        <BuscadorPractica
                                            ref={buscadorRef}
                                            cod={parametroBusqueda}
                                            label="Practica"
                                            setCod={(val) => setearValor("parametroBusqueda", val)}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <SelectValidator
                                            onChange={handleInputChange}
                                            name="idProvincia"
                                            value={idProvincia}
                                            label="Provincia"
                                            fullWidth={true}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                provincias.map((t) => (
                                                    <MenuItem key={t.id_provincia} value={t.id_provincia}>
                                                        {t.descripcion_provincia}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <SelectValidator
                                            name="idLocalidad"
                                            value={idLocalidad}
                                            label="Localidades"
                                            fullWidth={true}
                                            onChange={handleInputChange}
                                            disabled={disableLocalidad}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                localidades.map((t) => (
                                                    idProvincia === t.id_provincia &&
                                                    <MenuItem key={t.id_localidad} value={t.id_localidad}>
                                                        {t.descripcion_localidad}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                                    <Grid item xs={2}>
                                        <Button variant="contained" color="primary" type="submit">
                                            Consultar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                        <TableGeneric
                            ref={componentRef}
                            data={prestadoresPorPractica}
                            columns={[
                                {
                                    label: "Práctica",
                                    id: "codigoPractica",
                                    sort: true
                                },
                                {
                                    label: "ID Efector",
                                    id: "idEfectorFacturacion",
                                    sort: true
                                },
                                {
                                    label: "Efector",
                                    id: "nombreEfector",
                                },
                                // {
                                //     label: "Localidades prestadores por efector",
                                //     id: "prestadores.cartillaPrestadores.cartillaPrestadoresDomicilio",
                                //     customBody: (item) => 
                                //         <ModalLocalidades  
                                //             item={item} 
                                //             centros={CentrosMedicos}
                                //             getLocalidades={getOnlyLocalidades}    
                                //         />
                                    
                                // },
                                {
                                    label: "Importe",
                                    id: "importe"
                                },
                                {
                                    label: "Fecha Inicio vigencia",
                                    id: "fechaInicioVigencia",
                                    customBody: (item) => moment(`${item.fechaInicioVigencia}`, 'YYYYMM').format("DD/MM/YYYY"),
                                    sort: true
                                },
                                {
                                    label: "Fecha Fin Vigencia",
                                    id: "fechaFinVigencia",
                                    customBody: (item) => moment(`${item.fechaFinVigencia}`, 'YYYYMM').format("DD/MM/YYYY"),
                                    sort: true
                                },
                            ]}
                        />
                    </Card>
                </Grid >
            </Grid >
        </div >
    )
};
export default PrestadoresPorPracticas;